import "whatwg-fetch";
import { appStore } from "@/store/AppModule";
class Http {

    public get<T>(url: string): Promise<T> {
        const promise = this.fetch("GET", url)
            .then(response => {
                return response.json();
            });

        return promise;
    }

    public post<TResponse>(url: string, data: any = null): Promise<TResponse> {

        const promise = this.fetch("POST", url, data)
            .then(response => {
                return response.json();
            });

        return promise;
    }

    private fetch(method: string, url: string, data: any = null, contentType: DataFormat = DataFormat.Json): Promise<Response> {

        const options: RequestInit = {
            method,
        };

        if (data != null) {
            switch (method) {
                case "GET":
                    options.body = this.CreateUrlSearchParams(data);
                    break;
                default:
                    options.body = JSON.stringify(data);
            }
        }

        let contentTypeHeaderValue: string = "";

        switch (contentType) {
            case DataFormat.Json:
                contentTypeHeaderValue = "application/json";
                break;
            default:
                contentTypeHeaderValue = "text/plain";
        }

        options.headers = {
            "Accept-Language": appStore.state.culture,
            "Content-Type": contentTypeHeaderValue,
            "X-Litium-Page": appStore.state.pageId,
            "X-Litium-Website": appStore.state.webSiteId,
            "X-Litium-Language": appStore.state.languageId
        };

        return fetch(url, options)
        .then(this.checkStatus);
    }

    private CreateUrlSearchParams(source: object): URLSearchParams {
        const data: URLSearchParams = new URLSearchParams();
        Object.entries(source)
            .forEach(([key, value]) => data.append(key, value));

        return data;
    }

    private async checkStatus(response: Response) {
        if (response.ok && response.status >= 200 && response.status < 300) {
            return response;
        } else {
            const responseText = await response.text();
            const data = responseText ? JSON.parse(responseText) : {};
            const error = data.message ? data.message : response.status.toString();

            throw new Error(error);
        }
    }
}

enum DataFormat {
    Json,
    FormData
}

export default new Http();
